export const hexToRgbA = (hex, alpha = 1) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",");
  }
  throw new Error("Bad Hex");
};

export const isMobile = () => {
  const match = window.matchMedia || window.msMatchMedia;
  if (match) {
    // const mq = match("(pointer:coarse)");
    const mq = match("(max-width: 480px)");
    return mq.matches;
  }
  return false;
};

export const debounce = (func, delay = 3000) => {
  let clearTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(clearTimer);
    clearTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const getTitleFromCamelCaseString = (camelCaseStr) => {
  const indexes = camelCaseStr
    .split("")
    .map((x, index) => x === x.toUpperCase() && index)
    .filter((x) => x);

  return (
    indexes.reduce((acc, curr, currindex, arr) => {
      return acc + camelCaseStr.slice(arr[currindex - 1], arr[currindex]) + " ";
    }, "") + camelCaseStr.slice(indexes[indexes.length - 1])
  );
};

export const Export2Doc = (element, filename = "fast-resume") => {
  var header =
    "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "xmlns='http://www.w3.org/TR/REC-html40'>" +
    "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
  var footer = "</body></html>";
  var sourceHTML = header + document.getElementById(element).innerHTML + footer;

  var source =
    "data:application/vnd.ms-word;charset=utf-8," +
    encodeURIComponent(sourceHTML);
  var fileDownload = document.createElement("a");
  document.body.appendChild(fileDownload);
  fileDownload.href = source;
  fileDownload.download = `${filename}.docx`;
  fileDownload.click();
  document.body.removeChild(fileDownload);
};

export const saveResumeToFile = (data) => {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  return (fileName="fast-resume-text.json") =>  {
      const json = JSON.stringify(data),
          blob = new Blob([json], {type: "octet/stream"}),
          url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
  };
  };

